<template>
    <b-modal id="modal-renegociacao-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalRenegociacaoDetalhe">
        <template v-slot:modal-header="{ close }">
            <h5 v-if="!(loading || error)">Renegociação nº {{ pedido.cd_renegociacao_divida }}</h5>
        </template>
        <template v-slot:default="{ hide }">
            <template v-if="loading || error">
                <div v-if="loading" class="text-center" style="background: rgba(255, 255, 255, 0.7); width: 100%; height: 100%; display: block; z-index: 10002; margin: 0;">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
                    <br /><span style="color: #004e86">Processando Aguarde...</span>
                </div>
            </template>
            <template v-else>
                <b-row>
                    <!-- Lado esquerdo ocupando todo o espaço vertical -->
                    <b-col cols="4">
                        <div class="modal-card pt-2 h-100">
                        <div class="modal-card-header">
                            <h3>Dados do Título</h3>
                        </div>
                        <div class="modal-card-body">
                                <span><b>Nosso Número:</b> {{ pedido.nm_nosso_numero }}</span>
                                <span><b>Nº Título:</b> {{ pedido.nm_nr_titulo }}</span>
                                <span><b>Valor do Título:</b> {{ currencyFormatter.format(pedido.vl_titulo) }}</span>
                                <span><b>Valor Protestado:</b> {{ currencyFormatter.format(pedido.vl_protesto) }}</span>
                                <span><b>Nome do Devedor:</b> {{ pedido.nm_devedor }}</span>
                                <span><b>Documento do Devedor:</b> {{ formatDocumento(pedido.nm_nr_documento_devedor) }}</span>
                                <span><b>Chave:</b> {{ pedido.nm_chave }}</span>
                                <span><b>Nº Protocolo:</b> {{ pedido.nm_nr_protocolo }}</span>
                                <span><b>Data Protocolo:</b> {{ pedido.dt_protocolof }}</span>
                                <span><b>Data Ocorrência:</b> {{ formatData(pedido.dt_ocorrencia) }}</span>
                                <span><b>Ocorrência:</b> {{ pedido.ds_ocorrencia }}</span>
                            </div>
                        </div>
                    </b-col>

                    <!-- Lado direito com dois blocos empilhados -->
                    <b-col cols="8" class="d-flex flex-column justify-content-between">
                        <div class="modal-card pt-2">
                        <div class="modal-card-header">
                            <h3>Dados da Renegociação</h3>
                        </div>
                        <div class="modal-card-body">
                            <span><b>Nº Pedido:</b> {{ pedido.cd_renegociacao_divida }}</span>
                            <span><b>Data Solicitação:</b> {{ formatData(pedido.dt_cadastro_proposta) }}</span>
                            <span><b>Valor Proposta:</b>
                              <template v-if="modoEdicaoLocal">
                                <b-input-group size="sm" style="max-width: 180px;">
                                  <b-input-group-prepend is-text>R$</b-input-group-prepend>
                                  <b-form-input v-model="vlPropostaEdit" type="text" @input="onInputProposta" autocomplete="off" />
                                </b-input-group>
                              </template>
                              <template v-else>
                                {{ currencyFormatter.format(pedido.vl_proposta) }}
                              </template>
                            </span>
                            <span><b>Desconto Aplicado (%):</b>
                              <template v-if="modoEdicaoLocal">
                                <b-input-group size="sm" style="max-width: 120px;">
                                  <b-form-input v-model="descontoPercentualEdit" type="text" @input="onInputDescontoPercentual" autocomplete="off" />
                                  <b-input-group-append is-text>%</b-input-group-append>
                                </b-input-group>
                              </template>
                              <template v-else>
                                {{ pedido.regra_desconto_percentual }}%
                              </template>
                            </span>
                            <span><b>Valor do desconto:</b>
                              <template v-if="modoEdicaoLocal">
                                <b-input-group size="sm" style="max-width: 180px;">
                                  <b-input-group-prepend is-text>R$</b-input-group-prepend>
                                  <b-form-input v-model="valorDescontoEdit" type="text" @input="onInputValorDesconto" autocomplete="off" />
                                </b-input-group>
                              </template>
                              <template v-else>
                                {{ currencyFormatter.format(valorDescontoEdit) }}
                              </template>
                            </span>
                            <div class="mt-2 d-flex gap-2">
                              <b-button size="sm" variant="outline-primary" @click="modoEdicaoLocal = true" v-if="!modoEdicaoLocal && [1,2].includes(parseInt(pedido.cd_renegociacao_divida_status))">Editar</b-button>
                              <b-button size="sm" variant="outline-success" @click="salvarEdicao" v-if="modoEdicaoLocal">Salvar</b-button>
                              <b-button size="sm" variant="outline-secondary" @click="cancelarEdicao" v-if="modoEdicaoLocal">Cancelar</b-button>
                            </div>
                            <span v-if="Number(pedido.regra_aumento_percentual) > 0">
                              <b>Acréscimo aplicado:</b> {{ pedido.regra_aumento_percentual }}%
                            </span>
                            <span v-if="Number(pedido.regra_aumento_percentual) > 0">
                              <b>Valor do acréscimo:</b> {{ currencyFormatter.format(Number(pedido.vl_protesto) * (Number(pedido.regra_aumento_percentual) / 100)) }}
                            </span>
                            <span v-if="Number(pedido.regra_multa_percentual) > 0">
                              <b>Multa aplicada:</b> {{ pedido.regra_multa_percentual }}%
                            </span>
                            <span v-if="Number(pedido.regra_multa_percentual) > 0">
                              <b>Valor da multa:</b> {{ currencyFormatter.format(Number(pedido.vl_protesto) * (Number(pedido.regra_multa_percentual) / 100)) }}
                            </span>
                            <span><b>Valor Custas Cancelamento:</b> {{ currencyFormatter.format(pedido.vl_custa_cancelamento) }}</span>
                            <span><b>Custo Plataforma:</b> {{ currencyFormatter.format(pedido.vl_taxa_servico) }}</span>
                            <span><b>Valor Total:</b> {{ currencyFormatter.format(Number(pedido.vl_total_pagar)) }}</span>
                            <span><b>Dt. Venc. Proposta:</b> {{ pedido.dt_vencimento_proposta }}
                              <template v-if="modoEdicaoLocal">
                                <b-form-input
                                  v-model="dtVencimentoEdit"
                                  type="date"
                                  style="max-width: 180px;"
                                  :value="formatDateInput(dtVencimentoEdit)"
                                  @focus="dtVencimentoEdit = formatDateInput(dtVencimentoEdit)"
                                />
                              </template>
                              <template v-else>
                                {{ pedido.dt_vencimento_proposta_fmt }}
                              </template>
                            </span>
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <span><b>Status:</b> {{ pedido.status_descricao }}</span>
                                <b-button size="sm" variant="primary" @click="baixarPDF(pedido.cd_renegociacao_divida)">
                                    <font-awesome-icon icon="file-pdf" /> PDF
                                </b-button>
                            </div>
                        </div>
                        </div>

                        <div class="modal-card pt-2 mt-2">
                        <div class="modal-card-header">
                            <h3>Dados do Cartório</h3>
                        </div>
                        <div class="modal-card-body">
                            <span><b>Nome:</b> {{ pedido.nome_cartorio }}</span>
                            <span><b>CNPJ:</b> {{ formatDocumento(pedido.cnpj_cartorio) }}</span>
                            <span><b>Telefone:</b> {{ formatTelefone(pedido.telefone_cartorio) }}</span>
                            <span><b>Email:</b> {{ pedido.email_cartorio }}</span>
                        </div>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-slot:modal-footer="{ ok }">
            <b-button :disabled="loading" size="lg" variant="success" @click="devolveResposta('s')">Fechar</b-button>
        </template>
    </b-modal>
</template>

<script>
import API from '../../services/api'
export default {
    props: {
        pedido: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            error: false,
            currencyFormatter: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }),
            modoEdicaoLocal: false,
            vlPropostaEdit: this.pedido.vl_proposta,
            descontoPercentualEdit: this.pedido.regra_desconto_percentual,
            valorDescontoEdit: this.calculaValorDesconto(this.pedido.vl_titulo, this.pedido.regra_desconto_percentual),
            dtVencimentoEdit: this.pedido.dt_vencimento_proposta
        }
    },
    watch: {
      pedido: {
        handler(val) {
          this.vlPropostaEdit = val.vl_proposta;
          this.descontoPercentualEdit = val.regra_desconto_percentual;
          this.valorDescontoEdit = this.calculaValorDesconto(val.vl_titulo, val.regra_desconto_percentual);
          this.dtVencimentoEdit = val.dt_vencimento_proposta;
          this.modoEdicaoLocal = false;
        },
        immediate: true
      }
    },
    methods: {
        formatData(data) {
            if (!data) return '';
            return data.split(' ')[0].split('-').reverse().join('/');
        },
        formatDocumento(doc) {
            if (!doc) return '';
            let v = doc.replace(/\D/g, "");
            if (v.length < 14) {
                return v.replace(/(\d{3})(\d)/, "$1.$2")
                        .replace(/(\d{3})(\d)/, "$1.$2")
                        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            } else {
                return v.replace(/^(\d{2})(\d)/, "$1.$2")
                        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                        .replace(/\.(\d{3})(\d)/, ".$1/$2")
                        .replace(/(\d{4})(\d)/, "$1-$2");
            }
        },
        formatTelefone(phone) {
            if (!phone) return '';
            let v = phone.replace(/\D/g, "");
            return v.replace(/(\d{2})(\d)/, "($1) $2")
                    .replace(/(\d{4,5})(\d{4})$/, "$1-$2");
        },
        devolveResposta(resposta) {
            this.cleanModal();
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-renegociacao-detalhe');
        },
        cleanModal(){
            this.$emit('update:pedido', {});
        },
        async baixarPDF(cd_renegociacao_divida) {
            const token = localStorage.getItem("jwtToken");

            const payload = {
                token: token,
                cd_renegociacao_divida: this.pedido.cd_renegociacao_divida
            };

            try {
                const response = await API.post(`renegociacao_divida_protestada/recuperar-pdf`, payload, {
                    responseType: 'blob' // importante para receber o PDF como arquivo
                });

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `renegociacao_${cd_renegociacao_divida}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                console.error("Erro ao baixar o PDF:", error);
                this.$swal({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Falha ao baixar o PDF da renegociação.'
                });
            }
        },
        calculaValorDesconto(valorTitulo, percentual) {
          let p = parseFloat(valorTitulo) || 0;
          let perc = parseFloat(percentual) || 0;
          return (p * perc / 100).toFixed(2);
        },
        onInputDescontoPercentual(val) {
          // Atualiza desconto e proposta a partir do percentual
          let perc = parseFloat(val.replace(',', '.')) || 0;
          let titulo = parseFloat(this.pedido.vl_titulo) || 0;
          let desconto = (titulo * perc / 100).toFixed(2);
          let proposta = (titulo - desconto).toFixed(2);
          this.descontoPercentualEdit = perc;
          this.valorDescontoEdit = desconto;
          this.vlPropostaEdit = proposta;
        },
        onInputProposta(val) {
          // Atualiza desconto e percentual a partir do valor da proposta
          let proposta = parseFloat(val.replace(',', '.')) || 0;
          let titulo = parseFloat(this.pedido.vl_titulo) || 0;
          let desconto = (titulo - proposta).toFixed(2);
          let perc = titulo > 0 ? ((desconto / titulo) * 100).toFixed(2) : 0;
          this.vlPropostaEdit = proposta;
          this.valorDescontoEdit = desconto;
          this.descontoPercentualEdit = perc;
        },
        onInputValorDesconto(val) {
          // Atualiza proposta e percentual a partir do valor do desconto
          let desconto = parseFloat(val.replace(',', '.')) || 0;
          let titulo = parseFloat(this.pedido.vl_titulo) || 0;
          let proposta = (titulo - desconto).toFixed(2);
          let perc = titulo > 0 ? ((desconto / titulo) * 100).toFixed(2) : 0;
          this.valorDescontoEdit = desconto;
          this.vlPropostaEdit = proposta;
          this.descontoPercentualEdit = perc;
        },
        salvarEdicao() {
          const token = localStorage.getItem("jwtToken");
          const payload = {
            token: token,
            cd_renegociacao_divida: this.pedido.cd_renegociacao_divida,
            vl_proposta: parseFloat(this.vlPropostaEdit),
            regra_desconto_percentual: parseFloat(this.descontoPercentualEdit),
            valor_desconto: parseFloat(this.valorDescontoEdit),
            dt_vencimento_proposta: this.dtVencimentoEdit
          };
          this.loading = true;
          API.post('renegociacao_divida_protestada/editar-pedido', payload)
            .then(() => {
              this.$set(this.pedido, 'vl_proposta', payload.vl_proposta);
              this.$set(this.pedido, 'regra_desconto_percentual', payload.regra_desconto_percentual);
              this.$set(this.pedido, 'valor_desconto', payload.valor_desconto);
              this.$set(this.pedido, 'dt_vencimento_proposta', payload.dt_vencimento_proposta);
              this.modoEdicaoLocal = false;
              this.$toasted && this.$toasted.success('Proposta atualizada com sucesso!');
              this.$bvModal.hide('modal-renegociacao-detalhe');
            })
            .catch(() => {
              this.$toasted && this.$toasted.error('Erro ao atualizar proposta.');
            })
            .finally(() => {
              this.loading = false;
            });
        },
        cancelarEdicao() {
          this.vlPropostaEdit = this.pedido.vl_proposta;
          this.descontoPercentualEdit = this.pedido.regra_desconto_percentual;
          this.valorDescontoEdit = this.calculaValorDesconto(this.pedido.vl_titulo, this.pedido.regra_desconto_percentual);
          this.dtVencimentoEdit = this.pedido.dt_vencimento_proposta;
          this.modoEdicaoLocal = false;
        },
        formatDateInput(date) {
          if (!date) return '';
          // Se já estiver no formato yyyy-mm-dd, retorna direto
          if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
          // Se vier como dd/mm/yyyy, converte
          const parts = date.split('/');
          if (parts.length === 3) {
            return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
          }
          return date;
        },
    }
}
</script>

<style scoped>
.modal-card {
    display: flex;
    flex-direction: column;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin-bottom: 30px;
    padding: 0 10px;
}
.modal-card-header {
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: .75rem 1.25rem;
}
.modal-card-body {
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}
h3 {
    font: bold 18px 'Open Sans', sans-serif;
    margin: 0;
}
span {
    font: normal 14px 'Open Sans', sans-serif;
    flex: 1 1 48%;
}
.percentual-box {
  background: #f6f6fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 12px;
  margin: 8px 0 8px 0;
}
.percentual-label {
  font-size: 0.95em;
  color: #666;
  margin-top: 2px;
  text-align: left;
}
</style>